export default function TimelineBlock({ item, left, width, onOpen, onDragStart, colorClass }) {
  const tooltipLines = [
    `${item.startTime || "--:--"} • ${item.durationLabel || "-"}`,
    `Klant: ${item.clientName || "-"}`,
    `Locatie: ${item.locationLabel || "-"}`,
    `Project: ${item.projectLabel || "-"}`,
    `Status: ${item.statusLabel || item.statusKey || "-"}`,
  ];
  if (item.hasConflict) tooltipLines.push("Let op: conflict met ander blok");

  return (
    <button
      type="button"
      draggable
      onDragStart={(event) => onDragStart(event, item, "timeline")}
      onClick={() => onOpen(item)}
      className={`group absolute top-2 flex h-12 items-center rounded-2xl border px-3 text-left text-xs font-semibold text-white shadow-sm ${
        item.hasConflict
          ? "border-rose-200 ring-2 ring-rose-300/90"
          : "border-white/20"
      } ${colorClass}`}
      style={{ left, width }}
      title={`${item.werkbonNummer} • ${item.title}${item.hasConflict ? " • Conflict" : ""}`}
    >
      <span className="truncate">
        {item.werkbonNummer || "Werkbon"} • {item.title}
      </span>
      <span className="ml-2 shrink-0 rounded-full bg-white/15 px-2 py-0.5 text-[10px] font-semibold">
        {item.statusLabel}
      </span>
      {item.hasConflict ? (
        <span className="ml-2 shrink-0 rounded-full bg-white/15 px-2 py-0.5 text-[10px] font-semibold">
          Conflict
        </span>
      ) : null}

      <span className="pointer-events-none absolute bottom-full left-0 z-30 mb-2 hidden w-[320px] rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-700 shadow-xl group-hover:block group-focus-visible:block">
        <span className="block font-semibold text-slate-900">
          {item.werkbonNummer || "Werkbon"} • {item.title || "-"}
        </span>
        <span className="mt-1 block space-y-0.5">
          {tooltipLines.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </span>
      </span>
    </button>
  );
}
